export enum RequestStatusEnum {
  NEW = 'new',
  IN_PROGRESS = 'in_progress',
  TO_DELIVER = 'to_deliver',
  FINISHED = 'finished',
}
